import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-form-challan',
  templateUrl: './print-form-challan.component.html',
  styleUrls: ['./print-form-challan.component.scss']
})
export class PrintFormChallanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/candidate/print-form-challan/print-form-challan.component.ts